export const TYPES_VOIE = [
    { code: 'ABE', libelle: 'abbaye' },
    { code: 'ACH', libelle: 'ancien chemin', fantoir: true },
    { code: 'AER', libelle: 'aérodrome', fantoir: true },
    { code: 'AERD', libelle: 'aérodrome' },
    { code: 'AERG', libelle: 'aérogare', fantoir: true },
    { code: 'AERP', libelle: 'aéroport' },
    { code: 'AGL', libelle: 'agglomération', fantoir: true },
    { code: 'AIRE', libelle: 'aire', fantoir: true },
    { code: 'ALL', libelle: 'allée', fantoir: true },
    { code: 'ALS', libelle: 'allées' },
    { code: 'ANGL', libelle: 'angle', fantoir: true },
    { code: 'ANSE', libelle: 'anse' },
    { code: 'ARC', libelle: 'arcade', fantoir: true },
    { code: 'ART', libelle: 'ancienne route', fantoir: true },
    { code: 'AUT', libelle: 'autoroute', fantoir: true },
    { code: 'AV', libelle: 'avenue', fantoir: true },
    { code: 'BAL', libelle: 'ballade' },
    { code: 'BASE', libelle: 'base', fantoir: true },
    { code: 'BAST', libelle: 'bastion' },
    { code: 'BAT', libelle: 'bâtiment' },
    { code: 'BCH', libelle: 'bas chemin' },
    { code: 'BCLE', libelle: 'boucle' },
    { code: 'BD', libelle: 'boulevard', fantoir: true },
    { code: 'BEGI', libelle: 'béguinage' },
    { code: 'BER', libelle: 'berge', fantoir: true },
    { code: 'BOIS', libelle: 'bois', fantoir: true },
    { code: 'BORD', libelle: 'bord', fantoir: true },
    { code: 'BRE', libelle: 'barrière', fantoir: true },
    { code: 'BRG', libelle: 'bourg', fantoir: true },
    { code: 'BRTL', libelle: 'bretelle', fantoir: true },
    { code: 'BSN', libelle: 'bassin', fantoir: true },
    { code: 'BSTD', libelle: 'bastide' },
    { code: 'BUT', libelle: 'butte' },
    { code: 'CAE', libelle: 'carriera', fantoir: true },
    { code: 'CALE', libelle: 'cale' },
    { code: 'CALL', libelle: 'callada', fantoir: true },
    { code: 'CAMI', libelle: 'camin', fantoir: true },
    { code: 'CAMP', libelle: 'camp', fantoir: true },
    { code: 'CAN', libelle: 'canal', fantoir: true },
    { code: 'CAR', libelle: 'carrefour', fantoir: true },
    { code: 'CARE', libelle: 'carrière', fantoir: true },
    { code: 'CARR', libelle: 'carré', fantoir: true },
    { code: 'CASR', libelle: 'caserne', fantoir: true },
    { code: 'CAU', libelle: 'carreau' },
    { code: 'CAV', libelle: 'cavée' },
    { code: 'CC', libelle: 'chemin communal', fantoir: true },
    { code: 'CCAL', libelle: 'centre commercial', fantoir: true },
    { code: 'CD', libelle: 'chemin departemental', fantoir: true },
    { code: 'CF', libelle: 'chemin forestier', fantoir: true },
    { code: 'CGNE', libelle: 'campagne' },
    { code: 'CHA', libelle: 'chasse', fantoir: true },
    { code: 'CHE', libelle: 'chemin', fantoir: true },
    { code: 'CHEM', libelle: 'cheminement', fantoir: true },
    { code: 'CHEZ', libelle: 'chez' },
    { code: 'CHI', libelle: 'charmille' },
    { code: 'CHL', libelle: 'chalet', fantoir: true },
    { code: 'CHP', libelle: 'champ', fantoir: true },
    { code: 'CHS', libelle: 'chaussée', fantoir: true },
    { code: 'CHT', libelle: 'château', fantoir: true },
    { code: 'CHV', libelle: 'chemin vicinal', fantoir: true },
    { code: 'CIAT', libelle: 'commissariat' },
    { code: 'CITE', libelle: 'cité', fantoir: true },
    { code: 'CIVE', libelle: 'coursive', fantoir: true },
    { code: 'CLOI', libelle: 'cloître' },
    { code: 'CLOS', libelle: 'clos', fantoir: true },
    { code: 'CLR', libelle: 'couloir', fantoir: true },
    { code: 'COIN', libelle: 'coin', fantoir: true },
    { code: 'COL', libelle: 'col', fantoir: true },
    { code: 'COLI', libelle: 'colline' },
    { code: 'COLL', libelle: 'college' },
    { code: 'COR', libelle: 'corniche', fantoir: true },
    { code: 'CORO', libelle: 'coron', fantoir: true },
    { code: 'COTE', libelle: 'côte', fantoir: true },
    { code: 'COTT', libelle: 'cottage' },
    { code: 'COUR', libelle: 'cour', fantoir: true },
    { code: 'CPG', libelle: 'camping', fantoir: true },
    { code: 'CR', libelle: 'chemin rural', fantoir: true },
    { code: 'CRS', libelle: 'cours', fantoir: true },
    { code: 'CRX', libelle: 'croix', fantoir: true },
    { code: 'CST', libelle: 'castel' },
    { code: 'CTR', libelle: 'contour', fantoir: true },
    { code: 'CTRE', libelle: 'centre', fantoir: true },
    { code: 'DARS', libelle: 'darse', fantoir: true },
    { code: 'DEG', libelle: 'degrés' },
    { code: 'DEVI', libelle: 'déviation', fantoir: true },
    { code: 'DIG', libelle: 'digue', fantoir: true },
    { code: 'DOM', libelle: 'domaine', fantoir: true },
    { code: 'DRA', libelle: 'draille', fantoir: true },
    { code: 'DSC', libelle: 'descente', fantoir: true },
    { code: 'EC', libelle: 'école' },
    { code: 'ECA', libelle: 'écart', fantoir: true },
    { code: 'ECL', libelle: 'écluse', fantoir: true },
    { code: 'EGL', libelle: 'église' },
    { code: 'EMBR', libelle: 'embranchement', fantoir: true },
    { code: 'EMP', libelle: 'emplacement', fantoir: true },
    { code: 'EN', libelle: 'enceinte' },
    { code: 'ENC', libelle: 'enclos', fantoir: true },
    { code: 'ENV', libelle: 'enclave', fantoir: true },
    { code: 'ESC', libelle: 'escalier', fantoir: true },
    { code: 'ESP', libelle: 'esplanade', fantoir: true },
    { code: 'ESPA', libelle: 'espace', fantoir: true },
    { code: 'ETNG', libelle: 'étang', fantoir: true },
    { code: 'FD', libelle: 'fond', fantoir: true },
    { code: 'FG', libelle: 'faubourg', fantoir: true },
    { code: 'FON', libelle: 'fontaine', fantoir: true },
    { code: 'FOR', libelle: 'forêt', fantoir: true },
    { code: 'FORM', libelle: 'forum' },
    { code: 'FORT', libelle: 'fort', fantoir: true },
    { code: 'FOS', libelle: 'fosse', fantoir: true },
    { code: 'FOYR', libelle: 'foyer' },
    { code: 'FRM', libelle: 'ferme', fantoir: true },
    { code: 'GAL', libelle: 'galerie', fantoir: true },
    { code: 'GALL', libelle: 'grande allée' },
    { code: 'GAM', libelle: 'galerie marchande' },
    { code: 'GARE', libelle: 'gare', fantoir: true },
    { code: 'GARN', libelle: 'garenne' },
    { code: 'GBD', libelle: 'grand boulevard', fantoir: true },
    { code: 'GDEN', libelle: 'grand ensemble' },
    { code: 'GDERT', libelle: 'grande route' },
    { code: 'GDR', libelle: 'grand rue' },
    { code: 'GDRT', libelle: 'grand route' },
    { code: 'GEND', libelle: 'gendarmerie' },
    { code: 'GPE', libelle: 'groupe' },
    { code: 'GPL', libelle: 'grande place', fantoir: true },
    { code: 'GPT', libelle: 'groupement' },
    { code: 'GR', libelle: 'grande rue', fantoir: true },
    { code: 'GREV', libelle: 'grève', fantoir: true },
    { code: 'GRI', libelle: 'grille' },
    { code: 'GRIM', libelle: 'grimpette' },
    { code: 'HAB', libelle: 'habitation', fantoir: true },
    { code: 'HAM', libelle: 'hameau', fantoir: true },
    { code: 'HCH', libelle: 'haut chemin' },
    { code: 'HIP', libelle: 'hippodrome', fantoir: true },
    { code: 'HLE', libelle: 'halle', fantoir: true },
    { code: 'HLG', libelle: 'halage', fantoir: true },
    { code: 'HLM', libelle: 'HLM', fantoir: true },
    { code: 'HTR', libelle: 'hauteur', fantoir: true },
    { code: 'ILE', libelle: 'île', fantoir: true },
    { code: 'ILOT', libelle: 'ilot', fantoir: true },
    { code: 'IMM', libelle: 'immeuble', fantoir: true },
    { code: 'IMP', libelle: 'impasse', fantoir: true },
    { code: 'JARD', libelle: 'jardin', fantoir: true },
    { code: 'JTE', libelle: 'jetée', fantoir: true },
    { code: 'LAC', libelle: 'lac', fantoir: true },
    { code: 'LD', libelle: 'lieu-dit', fantoir: true },
    { code: 'LEVE', libelle: 'levée', fantoir: true },
    { code: 'LICE', libelle: 'lices', fantoir: true },
    { code: 'LIGN', libelle: 'ligne', fantoir: true },
    { code: 'LOT', libelle: 'lotissement', fantoir: true },
    { code: 'LRUEL', libelle: 'longue ruelle' },
    { code: 'LYC', libelle: 'lycée' },
    { code: 'MAIL', libelle: 'mail', fantoir: true },
    { code: 'MAIR', libelle: 'mairie' },
    { code: 'MAIS', libelle: 'maison', fantoir: true },
    { code: 'MAN', libelle: 'manoir' },
    { code: 'MAR', libelle: 'marché', fantoir: true },
    { code: 'MARE', libelle: 'mare', fantoir: true },
    { code: 'MAS', libelle: 'mas', fantoir: true },
    { code: 'MET', libelle: 'métro' },
    { code: 'MF', libelle: 'maison forestière' },
    { code: 'MLN', libelle: 'moulin' },
    { code: 'MNE', libelle: 'morne', fantoir: true },
    { code: 'MRN', libelle: 'marina', fantoir: true },
    { code: 'MTE', libelle: 'montée', fantoir: true },
    { code: 'MUS', libelle: 'musée' },
    { code: 'NTE', libelle: 'nouvelle route', fantoir: true },
    { code: 'PAC', libelle: 'pôle d\'activités' },
    { code: 'PAE', libelle: 'petite avenue', fantoir: true },
    { code: 'PAL', libelle: 'palais' },
    { code: 'PARC', libelle: 'parc', fantoir: true },
    { code: 'PAS', libelle: 'passage', fantoir: true },
    { code: 'PASS', libelle: 'passe', fantoir: true },
    { code: 'PAT', libelle: 'patio' },
    { code: 'PAV', libelle: 'pavillon' },
    { code: 'PCH', libelle: 'petit chemin', fantoir: true },
    { code: 'PCHE', libelle: 'porche', fantoir: true },
    { code: 'PERI', libelle: 'périphérique' },
    { code: 'PHAR', libelle: 'phare', fantoir: true },
    { code: 'PIM', libelle: 'petite impasse' },
    { code: 'PISC', libelle: 'piscine' },
    { code: 'PIST', libelle: 'piste', fantoir: true },
    { code: 'PKG', libelle: 'parking', fantoir: true },
    { code: 'PL', libelle: 'place', fantoir: true },
    { code: 'PLA', libelle: 'placa', fantoir: true },
    { code: 'PLAG', libelle: 'plage', fantoir: true },
    { code: 'PLAN', libelle: 'plan', fantoir: true },
    { code: 'PLCI', libelle: 'placis', fantoir: true },
    { code: 'PLCT', libelle: 'placette' },
    { code: 'PLE', libelle: 'passerelle', fantoir: true },
    { code: 'PLN', libelle: 'plaine', fantoir: true },
    { code: 'PLSN', libelle: 'plasenn' },
    { code: 'PLT', libelle: 'plateau', fantoir: true },
    { code: 'PN', libelle: 'passage à niveau' },
    { code: 'PNT', libelle: 'pointe', fantoir: true },
    { code: 'PONT', libelle: 'pont', fantoir: true },
    { code: 'PORQ', libelle: 'portique', fantoir: true },
    { code: 'PORT', libelle: 'port', fantoir: true },
    { code: 'POST', libelle: 'poste', fantoir: true },
    { code: 'POT', libelle: 'poterne', fantoir: true },
    { code: 'POUR', libelle: 'pourtour' },
    { code: 'PRE', libelle: 'pré' },
    { code: 'PRO', libelle: 'promenade', fantoir: true },
    { code: 'PROM', libelle: 'promenade', fantoir: true },
    { code: 'PRQ', libelle: 'presqu\'île' },
    { code: 'PRT', libelle: 'petite route', fantoir: true },
    { code: 'PRV', libelle: 'parvis', fantoir: true },
    { code: 'PSTY', libelle: 'péristyle' },
    { code: 'PTA', libelle: 'petite allée', fantoir: true },
    { code: 'PTE', libelle: 'porte', fantoir: true },
    { code: 'PTR', libelle: 'petite rue', fantoir: true },
    { code: 'PTTE', libelle: 'placette', fantoir: true },
    { code: 'QU', libelle: 'quai' },
    { code: 'QUA', libelle: 'quartier', fantoir: true },
    { code: 'QUAI', libelle: 'quai', fantoir: true },
    { code: 'R', libelle: 'rue', fantoir: true },
    { code: 'RAC', libelle: 'raccourci', fantoir: true },
    { code: 'RAID', libelle: 'raidillon' },
    { code: 'RD', libelle: 'route départementale' },
    { code: 'REM', libelle: 'rempart', fantoir: true },
    { code: 'RES', libelle: 'résidence', fantoir: true },
    { code: 'RIVE', libelle: 'rive', fantoir: true },
    { code: 'RLE', libelle: 'ruelle', fantoir: true },
    { code: 'RN', libelle: 'route nationale' },
    { code: 'ROC', libelle: 'rocade', fantoir: true },
    { code: 'ROQT', libelle: 'roquet' },
    { code: 'RPE', libelle: 'rampe', fantoir: true },
    { code: 'RPT', libelle: 'rond-point', fantoir: true },
    { code: 'RTD', libelle: 'rotonde', fantoir: true },
    { code: 'RTE', libelle: 'route', fantoir: true },
    { code: 'RUE', libelle: 'rue', fantoir: true },
    { code: 'RUET', libelle: 'ruette', fantoir: true },
    { code: 'RUIS', libelle: 'ruisseau', fantoir: true },
    { code: 'RULT', libelle: 'ruellette', fantoir: true },
    { code: 'RVE', libelle: 'ravine', fantoir: true },
    { code: 'SAS', libelle: 'sas', fantoir: true },
    { code: 'SECT', libelle: 'secteur' },
    { code: 'SEN', libelle: 'sentier', fantoir: true },
    { code: 'SQ', libelle: 'square', fantoir: true },
    { code: 'STA', libelle: 'station', fantoir: true },
    { code: 'STDE', libelle: 'stade', fantoir: true },
    { code: 'TER', libelle: 'terre', fantoir: true },
    { code: 'TOUR', libelle: 'tour', fantoir: true },
    { code: 'TPL', libelle: 'terre-plein', fantoir: true },
    { code: 'TRA', libelle: 'traverse', fantoir: true },
    { code: 'TRAB', libelle: 'traboule', fantoir: true },
    { code: 'TRN', libelle: 'terrain', fantoir: true },
    { code: 'TRT', libelle: 'tertre', fantoir: true },
    { code: 'TSSE', libelle: 'terrasse', fantoir: true },
    { code: 'TUN', libelle: 'tunnel', fantoir: true },
    { code: 'UNIV', libelle: 'université' },
    { code: 'VAL', libelle: 'val', fantoir: true },
    { code: 'VALL', libelle: 'vallon', fantoir: true },
    { code: 'VC', libelle: 'voie communale', fantoir: true },
    { code: 'VCHE', libelle: 'vieux chemin', fantoir: true },
    { code: 'VEN', libelle: 'venelle', fantoir: true },
    { code: 'VGE', libelle: 'village', fantoir: true },
    { code: 'VIA', libelle: 'via', fantoir: true },
    { code: 'VIAD', libelle: 'viaduc', fantoir: true },
    { code: 'VIL', libelle: 'ville', fantoir: true },
    { code: 'VLA', libelle: 'villa', fantoir: true },
    { code: 'VLGE', libelle: 'village', fantoir: true },
    { code: 'VOI', libelle: 'voie' },
    { code: 'VOIE', libelle: 'voie', fantoir: true },
    { code: 'VOIR', libelle: 'voirie', fantoir: true },
    { code: 'VOUT', libelle: 'voute', fantoir: true },
    { code: 'VOY', libelle: 'voyeul', fantoir: true },
    { code: 'VRUE', libelle: 'vieille rue' },
    { code: 'VTE', libelle: 'vieille route', fantoir: true },
    { code: 'ZA', libelle: 'zone d\'activité', fantoir: true },
    { code: 'ZAC', libelle: 'zone d\'aménagement concerté', fantoir: true },
    { code: 'ZAD', libelle: 'zone d\'aménagement différé', fantoir: true },
    { code: 'ZAE', libelle: 'zone d\'aménagement économique' },
    { code: 'ZAL', libelle: 'zone d’aménagement logistique' },
    { code: 'ZAM', libelle: 'zone d’aménagement mixte' },
    { code: 'ZAS', libelle: 'zone d’aménagement spécifique' },
    { code: 'ZC', libelle: 'zone commerciale' },
    { code: 'ZI', libelle: 'zone industrielle', fantoir: true },
    { code: 'ZIP', libelle: 'zone industrielle portuaire' },
    { code: 'ZONE', libelle: 'zone', fantoir: true },
    { code: 'ZUP', libelle: 'zone à urbaniser en priorité', fantoir: true },
];
//# sourceMappingURL=types-voie.js.map